"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_BLOCK_DIAGRAM_KNOBS = exports.SPACING_KNOB_MAX = exports.SPACING_KNOB_MIN = exports.LAYOUT_ENGINE_VERSION = void 0;
exports.resolveBlockDiagramKnobs = resolveBlockDiagramKnobs;
exports.computeBlockDiagramLayout = computeBlockDiagramLayout;
exports.compileBlockDiagram = compileBlockDiagram;
const compute_layout_1 = require("./layout/compute-layout");
const voltage_1 = require("./layout/voltage");
const derive_variant_1 = require("./variants/derive-variant");
const emit_project_model_1 = require("./emit/emit-project-model");
exports.LAYOUT_ENGINE_VERSION = '1.2.0';
exports.SPACING_KNOB_MIN = 0.9;
exports.SPACING_KNOB_MAX = 1.3;
exports.DEFAULT_BLOCK_DIAGRAM_KNOBS = {
    spacing: exports.SPACING_KNOB_MAX,
    showEdgeLabels: false,
    showArrows: false,
};
function resolveBlockDiagramKnobs(doc, knobs) {
    return {
        spacing: knobs?.spacing ?? doc?.placement?.spacing ?? exports.DEFAULT_BLOCK_DIAGRAM_KNOBS.spacing,
        showEdgeLabels: knobs?.showEdgeLabels ?? exports.DEFAULT_BLOCK_DIAGRAM_KNOBS.showEdgeLabels,
        showArrows: knobs?.showArrows ?? exports.DEFAULT_BLOCK_DIAGRAM_KNOBS.showArrows,
    };
}
function computeBlockDiagramLayout(doc, variant, knobs) {
    const edges = (0, derive_variant_1.deriveVariant)(doc, variant);
    const scale = (0, voltage_1.computeVoltageScale)(variant === 'full' ? edges : (0, derive_variant_1.deriveVariant)(doc, 'full'));
    const { spacing } = resolveBlockDiagramKnobs(doc, knobs);
    return (0, compute_layout_1.computeLayout)(doc.blocks, edges, doc.placement, spacing, scale);
}
function compileBlockDiagram(doc, variant, knobs) {
    const resolved = resolveBlockDiagramKnobs(doc, knobs);
    const layout = computeBlockDiagramLayout(doc, variant, resolved);
    const voltageScale = (0, voltage_1.computeVoltageScale)((0, derive_variant_1.deriveVariant)(doc, 'full'));
    const projectModel = (0, emit_project_model_1.emitProjectModel)(doc.blocks, layout, {
        title: doc.title,
        showEdgeLabels: resolved.showEdgeLabels,
        showArrows: resolved.showArrows,
    });
    return { projectModel, layout, voltageScale };
}
//# sourceMappingURL=compile.js.map